export const eventTypes = {
  EVENT: "EVENT",
};

const createMilestoneAndTaskEvent = (event, item) => {
  // Extract entity information from event data
  // Entity info can be at top level or nested in processData
  const entityId =
    event.data?.entityId ||
    event.data?.processData?.entityData?.id ||
    event.data?.processData?.entity_id;
  const entityName =
    event.data?.entityName ||
    event.data?.processData?.entityData?.name ||
    event.data?.processData?.entity_name;
  const entityCountry =
    event.data?.entityCountry ||
    event.data?.processData?.entityData?.country ||
    event.data?.processData?.entity_country;
  const entityTimezone =
    event.data?.timezone ||
    event.data?.processData?.entityData?.timezone ||
    event.data?.processData?.entity_timezone;

  console.log("createMilestoneAndTaskEvent - event.data:", event.data);
  console.log("createMilestoneAndTaskEvent - entityId:", entityId);
  console.log(
    "createMilestoneAndTaskEvent - processData:",
    event.data?.processData,
  );

  // Validate due_date before creating Date objects
  const dueDate = event.data?.due_date;
  const startDate = dueDate ? new Date(dueDate) : null;
  const endDate = dueDate ? new Date(dueDate) : null;
  const dueDateUtc = dueDate ? new Date(dueDate) : null;

  // If dates are Invalid Date, set to null
  const validStartDate =
    startDate && !isNaN(startDate.getTime()) ? startDate : null;
  const validEndDate = endDate && !isNaN(endDate.getTime()) ? endDate : null;
  const validDueDateUtc =
    dueDateUtc && !isNaN(dueDateUtc.getTime()) ? dueDateUtc : null;

  return {
    title: event.data?.name,
    status: event.data?.statusData,
    label: event.data?.serviceData.name,
    subTitle: event.data?.owner,
    start: validStartDate,
    end: validEndDate,
    type: eventTypes.EVENT,
    backgroundColor: event.data?.serviceData.secondary_color,
    color: event.data?.serviceData.primary_color,
    process: event.data?.processData?.id,
    id: event.type === "Milestones" ? event.data?.id : event.data?.milestone,
    filterType: event.type,
    totalCount: item.totalCount,
    due_date_utc: validDueDateUtc,
    entityData: {
      id: entityId,
      name: entityName,
      country: entityCountry,
      timezone: entityTimezone,
    },
    processData: event.data?.processData,
    entity: entityId,
  };
};

export const convertDataToCalendarEvents = (data = []) => {
  const events = [];
  const seenIds = new Set();

  data.forEach((item) => {
    item.items.forEach((event) => {
      if (event) {
        const baseId =
          event.type === "Milestones" ? event.data?.id : event.data?.milestone;
        // Include event type in the ID to avoid collisions between Milestones and Tasks
        const eventId = `${event.type}-${baseId}`;

        // Skip if we've already processed this event ID
        if (seenIds.has(eventId)) {
          return;
        }

        seenIds.add(eventId);
        events.push(createMilestoneAndTaskEvent(event, item));
      }
    });
  });

  return events;
};
